module.exports = __webpack_public_path__ + "img/8.8af4fcc4.jpg";